import { Component } from "@/types"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { cx } from "@/utils/cx"
import { TestimonialCard } from "./TestimonialCard/TestimonialCard"

export const COMPONENT_NAME = "testimonials"

export const presets = {}

export interface Props extends Component {}

export function Testimonials({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(``, className)} data-test={testId}>
      <div className="sr-only">Testimonials</div>
      <MarketingSection
        className={cx(`max-w-[100vw] overflow-x-auto `, `min-[640px]:max-w-screen-marketing`)}
      >
        <div
          className={cx(
            `flex min-[640px]:grid min-[640px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6`,
            ``,
          )}
        >
          <div className={cx(`flex gap-6`, `min-[640px]:flex-col`)}>
            <TestimonialCard
              quote="I loved the intro to python, the info on setting up custom shell environments for productivity, and the intro to RAM, C, shellcode exploits, etc. I'm amazed how much was covered, how well everything was covered, and how comfortable I felt afterwards trying out a lot more on my own, despite having felt some hesitancy about some of these topics previously."
              author="Austin Warden"
              credit="Cyber Security Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="SANS Foundations has given me the platform and tools I need to learn at my own speed, connect with Subject Matter Experts without difficulty, and access on-demand learning resources whenever I want to put what I've learned into practice."
              author="Henry Scott IV"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
          </div>
          <div className={cx(`flex gap-6`, `min-[640px]:flex-col`)}>
            <TestimonialCard
              quote="The SANS Foundations training is world-class, superb platform!"
              author="Alex Rodriguez"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="The course is very comprehensive and has given me a better understanding of how IT and security are interconnected. I had many 'light bulb' moments going through the course."
              author="Audrey Nelson Salmon"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="Highly recommend this course for anyone who is interested in a career in Cyber Security. Excellent for beginners through to those who already work in IT."
              author="Kerry Eaton"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
          </div>
          <div className={cx(`flex gap-6`, `min-[640px]:hidden md:flex md:flex-col`)}>
            <TestimonialCard
              quote="If you have no background in computing, this is a great course to give you a foundation necessary for developing more advanced skills and gaining more advanced knowledge."
              author="Jason Jordan"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="SANS Foundations has helped me learn the fundamentals of IT and Cybersecurity with great ease! James Lyne is a genius in his field and an excellent teacher in this course!"
              author="Andrew Kamlet"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="I have learnt more in this course than a year's worth of experience. It has filled in many gaps in my knowledge."
              author="Daniel King"
              credit="Foundations Student"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
          </div>
          <div className={cx(`flex gap-6`, `min-[640px]:hidden lg:flex lg:flex-col`)}>
            <TestimonialCard
              quote="All of the course materials were clear, concise, and had plenty of down to earth explanations of complicated cyber security concepts. Overall I would highly recommend SANS Foundations for beginners and intermediate cyber professionals who want to revisit the fundamentals and establish a solid base of knowledge to build your career on top of."
              author="Austin Warden"
              credit="Cyber Security Professional"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <TestimonialCard
              quote="The SANS Foundations course helped me land my dream cybersecurity internship as it built my knowledge in core computer hardware/software modules along with security fundamentals."
              author="Kirti Nangia"
              credit="Vulnerability Analyst"
              className={cx(
                `shrink-0 min-w-[200px] w-[74vw]`,
                "min-[640px]:w-auto min-[640px]:min-w-none",
              )}
            />
            <div className="w-px shrink-0 min-[640px]:hidden" />
          </div>
        </div>
      </MarketingSection>
    </div>
  )
}
